import React from 'react'

import { useNavigate } from 'react-router-dom'

import { ContentBack } from './styles'

const BackButton = ({
  goBack,
  withText = true,
  alignment,
}: {
  goBack?: () => void
  withText?: boolean
  alignment?: string
}) => {
  const navigate = useNavigate()

  const goBackFn = () => {
    goBack ? goBack() : navigate(-1)
  }
  return (
    <ContentBack onClick={goBackFn} $alignment={alignment}>
      <div className="arrow-right-back" />
      {withText && <p>volver</p>}
    </ContentBack>
  )
}

export default BackButton
